import { SECURITY_EVENTS, EVENT_SEVERITY } from './constants';

export function subscribePrintGuard(logSecurityEvent, policy) {
  if (typeof window === 'undefined' || !policy.blockPrint) return () => {};
  const handler = () => {
    logSecurityEvent({
      type: SECURITY_EVENTS.PRINT_ATTEMPT,
      severity: EVENT_SEVERITY[SECURITY_EVENTS.PRINT_ATTEMPT],
      message: 'Print dialog was invoked'
    });
  };
  window.addEventListener('beforeprint', handler);
  return () => window.removeEventListener('beforeprint', handler);
}
